import { create } from 'zustand'
import { apiFetch } from '@/lib/api'

/**
 * Feature-flag store. Single fetch on app mount via FeatureFlagBootstrap;
 * no live propagation during a session (page reload to refresh).
 *
 * State shape:
 *   - flagMap:  { [name]: boolean }  evaluated for the current user.
 *               Empty until bootstrap completes.
 *   - loading:  true until the first fetch resolves (success or failure).
 *   - error:    populated only on fetch failure; flag reads still
 *               return false for everything.
 */
export const useFeatureFlagStore = create((set) => ({
  flagMap: {},
  loading: true,
  error: null,
  load: async () => {
    try {
      const res = await apiFetch('/api/flags')
      if (!res.ok) throw new Error(`/api/flags returned ${res.status}`)
      const flagMap = await res.json()
      set({ flagMap, loading: false, error: null })
    } catch (err) {
      // Fail-safe-to-false: keep flagMap empty so every useFeatureFlag call
      // returns false. Error is recorded for observability but not surfaced.
      set({ flagMap: {}, loading: false, error: err })
    }
  },
}))
